<!-- @format -->

<template>
  <span v-if="tweenedNumber !== 0">{{ animatedNumber }}</span>
  <span v-else>{{ formatNr(startNumber, fmt) }}</span>
</template>

<script>
import gsap from "gsap";
import numeral from "numeral";
export default {
  name: "AnimatedNumber",

  props: {
    // The value that we'll be tweening to.
    number: Number,
    fmt: String,
    startNumber: Number,
  },
  data() {
    return {
      tweenedNumber: 0,
    };
  },
  computed: {
    animatedNumber: function() {
      return this.formatNr(this.tweenedNumber);
    },
  },
  watch: {
    number: function(newValue) {
      gsap.to(this.$data, { duration: 0.85, tweenedNumber: newValue });
    },
  },
  methods: {
    formatNr(val) {
      if (this.fmt) return numeral(val).format(this.fmt);
      else return numeral(val).format("0,0.0a");
    },
  },
};
</script>
